export default __webpack_public_path__ + "media/images/features/ana/masuda-6af32d90077a66071d0cb2bb86c194eb.jpg";